import '.d{display:flex;}.ssr-plugin'
import '.x{align-items:stretch;}.ssr-plugin'
import '.ad{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.dq{background:var(--palette-white);}.ssr-plugin'
import '.av{flex-grow:1;}.ssr-plugin'
import '.z{align-items:center;}.ssr-plugin'
import '.ag{max-width:77.5rem;}.ssr-plugin'
import '.fm{justify-content:stretch;}.ssr-plugin'
import '.b8{position:sticky;}.ssr-plugin'
import '.b9{top:0px;}.ssr-plugin'
import '.bd{z-index:10;}.ssr-plugin'
import '.fn{padding-block:1rem;}.ssr-plugin'
import '.fo{height:3rem;}.ssr-plugin'
import '.bn{justify-content:space-between;}.ssr-plugin'
import '.c9{flex-wrap:wrap;}.ssr-plugin'
import '.fq{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.ey{margin-top:2rem;}.ssr-plugin'
import '.h1{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d x ad e dq"
      >
        <div className="av d z ad e"
        >
          <div className="ag d e fm b8 b9 bd"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="fn fo d bn z c9"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="fq d e x ey h1 ag"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
